export default "__VITE_ASSET__c3f1b561__"